/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface AbortAssetUploadResponseContent
 */
export interface AbortAssetUploadResponseContent {
    /**
     * 
     * @type {string}
     * @memberof AbortAssetUploadResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the AbortAssetUploadResponseContent interface.
 */
export function instanceOfAbortAssetUploadResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    return isInstance;
}

export function AbortAssetUploadResponseContentFromJSON(json: any): AbortAssetUploadResponseContent {
    return AbortAssetUploadResponseContentFromJSONTyped(json, false);
}

export function AbortAssetUploadResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): AbortAssetUploadResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': json['message'],
    };
}

export function AbortAssetUploadResponseContentToJSON(value?: AbortAssetUploadResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

